@use 'sass:map';

@use '../../../scss/global/spacing';
@use '../../../scss/global/border';
@use '../../../scss/global/typography';
@use '../../../scss/global/breakpoints';

@use './alert.vars' as *;
@use './alert.mixins' as mixins;

:host {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: spacing.$spacer-4;
  background-color: var(--background-color);
  border-radius: border.$radius-1;
  border-style: solid;
  border-width: 1px;
  border-color: var(--border-color);

  @include mixins.alert-text;

  .fds-alert {
    &__title {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin: 0;
      width: 100%;
      container-type: inline-size;
      container-name: header;
    }

    &__header-wrapper {
      display: flex;
      align-items: center;
      gap: spacing.$spacer-4;

      @include breakpoints.container-xs(header) {
        flex-direction: var(--header-wrapper-flex-direction);
        align-items: var(--header-wrapper-align-items);
      }
    }

    &__icon {
      color: var(--icon-color);
    }

    &__description {
      display: flex;
      flex-direction: column;
      gap: spacing.$spacer-4;

      slot[name='alert-button']::slotted(*) {
        align-self: flex-end;
      }
    }
  }
}

::slotted(.fds-alert__header) {
  flex: 1;
  overflow-wrap: anywhere;

  @include typography.body-style(700);
}

@include mixins.alert-info;

@include mixins.alert-success;

@include mixins.alert-warning;

@include mixins.alert-error;

@include mixins.alert-hidden;
